function updateRigFormButton() {
  const buttonContainer = document.querySelector(
    ".cart-drawer-button-container"
  );

  if(!buttonContainer) return
  buttonContainer.innerHTML = "";
  const link = document.createElement("button");
  link.className = "cart-drawer-button";
  link.innerText = "Checkout";
  buttonContainer.appendChild(link);
  addPoints()
}

const sendRigDetails = async (rigDetails) => {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      attributes: {
        Make: rigDetails.make,
        Model: rigDetails.model,
        Year: rigDetails.year,
        Trim: rigDetails.length ? rigDetails.length : "",
      },
    }),
  });

  if (!response.ok) {
    throw new Error("Network response was not ok");
  } else {
    return response.json();
  }
};
// LOGIC FOR ADD THE POINTS TO ORDER
function addPoints() {
  const totalPoints = document.querySelector('.cart-drawer__points-sidecart-total p:nth-of-type(2)')?.textContent 

  document.querySelector('.cart-drawer-button-container')?.addEventListener('click', async (e) => {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            total_points: +totalPoints,
          },
        }),
      });
    const data = await response.json()

      if (!response.ok) {
        throw new Error("Network response was not ok");
      } else {
        window.location.href = "/checkout"
        return response.json();
      }
    })
}

async function deleteProducts() {
  const response = await fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
    
  } else {
    return response.json();
  }
}

async function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  document.querySelector("html").style.overflow = "hidden";
  // let rigDetails = localStorage.getItem("rvRigDetails");
  // rigDetails = JSON.parse(rigDetails);
  // if (rigDetails) {
  //   updateRigFormButton();
  //   rigDetails = rigDetails.mmy;
  //   try {
  //     await sendRigDetails(rigDetails);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
  document.querySelector("html").style.overflow = "visible";
}

// logic for hidden if some product excluded
function validExcludedProduct(items) {
  if (items.length === 1) {
    items.forEach((item) => {
      if (
        item.product_id === 6569175679012 ||
        item.product_id === 6801803378724 ||
        item.product_id === 6790389301284 ||
        item.product_id === 6571524685860 ||
        item.product_id === 6570871554084
      ) {
        setTimeout(() => {
          if (document.querySelector(".extended-content")) {
            document
              .querySelector(".extended-content")
              .classList.add("extended-content--hidden");
          }
        }, 500);
      }
    });
  }
}

async function removeProductExtended(items) {
  items.forEach(async (item) => {
    if (item.product_id === 7090573606948) {
      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [item.key]: 0 } }),
      });
      updateCartDrawer();
    }
  });
}
function formatNumber(number) {
  let strNumber = number.toString();
  if (strNumber.length > 2) {
    let formattedNumber = strNumber.slice(0, -2) + "." + strNumber.slice(-2);
    return +formattedNumber;
  } else {
    return +"0." + ("0" + strNumber).slice(-2);
  }
}

async function updateInfoWarranry() {
  const $extenPrice = document.querySelector(".extended-content-price");
  const $extenInput = document.querySelector(".extended-form input");
  const res = await fetch("/cart.js");
  const cart = await res.json();
  const formattedNumber = formatNumber(cart.total_price);
  if (!$extenPrice && !$extenPrice) return;
  
  switch (true) {
    case formattedNumber >= 0 && formattedNumber <= 49.99:
      $extenPrice.textContent = "6.99";
      $extenInput.value = "40350994956324";
      $extenInput.setAttribute("data-variant-id", "40350994956324");
      break;
    case formattedNumber >= 50.0 && formattedNumber <= 74.99:
      $extenPrice.textContent = "18.75";
      $extenInput.value = "40350995021860";
      $extenInput.setAttribute("data-variant-id", "40350995021860");
      break;
    case formattedNumber >= 75.0 && formattedNumber <= 99.99:
      $extenPrice.textContent = "25.00";
      $extenInput.value = "40350995054628";
      $extenInput.setAttribute("data-variant-id", "40350995054628");
      break;
    case formattedNumber >= 100.0 && formattedNumber <= 124.99:
      $extenPrice.textContent = "31.25";
      $extenInput.value = "40350995087396";
      $extenInput.setAttribute("data-variant-id", "40350995087396");
      break;
    case formattedNumber >= 125.0 && formattedNumber <= 149.99:
      $extenPrice.textContent = "37.50";
      $extenInput.value = "40350995120164";
      $extenInput.setAttribute("data-variant-id", "40350995120164");
      break;
    case formattedNumber >= 150.0 && formattedNumber <= 174.99:
      $extenPrice.textContent = "43.75";
      $extenInput.value = "40350995152932";
      $extenInput.setAttribute("data-variant-id", "40350995152932");
      break;
    case formattedNumber >= 175.0 && formattedNumber <= 199.99:
      $extenPrice.textContent = "50.00";
      $extenInput.value = "40350995185700";
      $extenInput.setAttribute("data-variant-id", "40350995185700");
      break;
    case formattedNumber >= 200.0 && formattedNumber <= 249.99:
      $extenPrice.textContent = "62.50";
      $extenInput.value = "40350995218468";
      $extenInput.setAttribute("data-variant-id", "40350995218468");
      break;
    case formattedNumber >= 250.0 && formattedNumber <= 299.99:
      $extenPrice.textContent = "75.00";
      $extenInput.value = "40350995251236";
      $extenInput.setAttribute("data-variant-id", "40350995251236");
      break;
    case formattedNumber >= 300.0 && formattedNumber <= 349.99:
      $extenPrice.textContent = "87.50";
      $extenInput.value = "40350995284004";
      $extenInput.setAttribute("data-variant-id", "40350995284004");
      break;
    case formattedNumber >= 350.0:
      $extenPrice.textContent = "99.99";
      $extenInput.value = "40350995316772";
      $extenInput.setAttribute("data-variant-id", "40350995316772");
      break;
    default:
      $extenPrice.textContent = "6.99";
      $extenInput.value = "40350994956324";
      $extenInput.setAttribute("data-variant-id", "40350994956324");
      break;
  }
}

function eventsFormRin() {
  const $inputs = document.querySelectorAll(".modal__content-input input");
  const $buttonChackout = document.querySelector(".modal__content-button");
  const $input1 = $inputs[0];
  const $input2 = $inputs[1];
  const $input3 = $inputs[2];
  const $input4 = $inputs[3];
  let rigDetails = localStorage.getItem("rvRigDetails");
  const totalPoints = document.querySelector('.cart-drawer__points-sidecart-total p:nth-of-type(2)')?.textContent  || null

  if ($inputs.length > 0 && $buttonChackout && !rigDetails) {
    function checkInputs() {
      if ($input1.value && $input2.value && $input3.value) {
        $buttonChackout.textContent = "Checkout";
      } else {
        $buttonChackout.textContent = "Enter rig info to check out";
      }
    }

    $buttonChackout.addEventListener("click", async (e) => {
      e.preventDefault();
      const labelInputs = ["make", "model", "year", "length"]
      const rigDetails = { mmy: {} };
      $inputs.forEach((input, index) => {
        const label = labelInputs[index];
        const value = input.value;
        rigDetails.mmy[label] = value;
      });
      localStorage.setItem("rvRigDetails", JSON.stringify(rigDetails));
      if ($input1.value && $input2.value && $input3.value) {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            attributes: {
              Make: $input1.value,
              Model: $input2.value,
              Year: $input3.value,
              Trim: $input4.value,
              total_points:+totalPoints
            },
          }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        document
          .querySelectorAll(".modal__content-input--error")
          .forEach((item) => {
            item.classList.remove("input-group--error");
          });
        window.location.href = "/checkout";
        $inputs.forEach((item) => {
          item.value = "";
        });
      } else {
        document
          .querySelectorAll(".modal__content-input--error")
          .forEach((item) => {
            if (!item.children[1].value) {
              item.classList.add("input-group--error");
            } else {
              item.classList.remove("input-group--error");
            }
          });
      }
    });

    $input1.addEventListener("input", checkInputs);
    $input2.addEventListener("input", checkInputs);
    $input3.addEventListener("input", checkInputs);
  }
}
function showModalRig() {
  const $buttonRig = document.querySelector(".enter-rig");
  const $close = document.querySelector(".modal-close--rig-info");
  if ($buttonRig && $close) {
    $buttonRig.addEventListener("click", (e) => {
      e.stopPropagation();
      document.querySelector("#rigInfoOverlay").classList.add("active");
      document.querySelector("#rigInfoOverlay").classList.add("fixed");
      document.querySelector("#rigInfoModal").classList.add("active");
      document.querySelector("#rigInfoModal").classList.add("visible");
    });
    $close.addEventListener("click", () => {
      document.querySelector("#rigInfoOverlay").classList.remove("active");
      document.querySelector("#rigInfoOverlay").classList.remove("fixed");
      document.querySelector("#rigInfoModal").classList.remove("active");
      document.querySelector("#rigInfoModal").classList.remove("visible");
    });
  }
}
function showModalExtended() {
  const $extWarrantyOverlay = document.querySelector("#extWarrantyOverlay");
  const $extWarrantyModal = document.querySelector("#extWarrantyModal");
  const $url = document.querySelector(".extended-paragraph--url");
  const $close = document.querySelector(".ext-modal-close");
  if ($url && $close) {
    $url.addEventListener("click", () => {
      $extWarrantyOverlay.classList.add("active");
      $extWarrantyOverlay.classList.add("fixed");
      $extWarrantyModal.classList.add("active");
      $extWarrantyModal.classList.add("visible");
    });

    $close.addEventListener("click", () => {
      $extWarrantyOverlay.classList.remove("active");
      $extWarrantyOverlay.classList.remove("fixed");
      $extWarrantyModal.classList.remove("active");
      $extWarrantyModal.classList.remove("visible");
    });
  }
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
    el.classList.add("visible");
  });
}

async function updateCartDrawer() {
  const res = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  removeCartItems();
}

function removeCartItems() {
  document.querySelectorAll(".remove__item").forEach((e) => {
    e.addEventListener("click", async () => {
      const rootItem =
        e.parentElement.parentElement.parentElement.parentElement;
      const key = rootItem.getAttribute("data-line-item-key");

      const res = await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });
      const cart = await res.json();
      removeProductExtended(cart.items);
      validExcludedProduct(cart.items);

      updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();

      });
    });
}
  
async function addToCart  (form) {
  await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });
  
      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      removeProductExtended(cart.items)
      validExcludedProduct(cart.items)
      updateCartItemCounts(cart.item_count)
  
      // Update cart
      await updateCartDrawer();
  
      // Open cart drawer
      openCartDrawer();
}
  
async function addCartDrawerListeners() {
  showModalExtended();
  showModalRig();
  eventsFormRin();
  updateInfoWarranry();
  addPoints();
  let rigDetails = localStorage.getItem("rvRigDetails");
  rigDetails = JSON.parse(rigDetails);
  if (rigDetails) {
    updateRigFormButton();
    rigDetails = rigDetails.mmy;
    try {
      await sendRigDetails(rigDetails);
    } catch (error) {
      console.error(error);
    }
  }

  document.querySelectorAll(".like-these__form").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);
      removeProductExtended(cart.items);

      // Update cart
      await updateCartDrawer();
    });
  });
  document.querySelectorAll(".extended-form").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Update cart
      await updateCartDrawer();
    });
  });

    // Update quantities
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Get line item key
          const rootItem =
            button.parentElement.parentElement.parentElement.parentElement
              .parentElement;
          const key = rootItem.getAttribute("data-line-item-key");
  
          // Get new quantity
          const currentQuantity = Number(
            button.parentElement.querySelector("input").value
          );
          const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
          );
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
  
          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: newQuantity } }),
          });
          const cart = await res.json();
          removeProductExtended(cart.items)
          validExcludedProduct(cart.items)
  
          updateCartItemCounts(cart.item_count);
  
          // Update cart
          updateCartDrawer();
        });
      });
  
    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
      e.stopPropagation();
    });
  
    document
      .querySelectorAll(".cart-drawer-header__close, .cart-drawer")
      .forEach((el) => {
        el.addEventListener("click", () => {
          console.log("closing drawer");
          closeCartDrawer();
        });
      });
  }
  
  addCartDrawerListeners();
  removeCartItems();
  addPoints()
  
document.querySelectorAll('form[action="/cart/add"], .add-on__atc').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });
  
      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      removeProductExtended(cart.items)
      validExcludedProduct(cart.items)
      updateCartItemCounts(cart.item_count)
  
      // Update cart
      await updateCartDrawer();
  
      // Open cart drawer
      openCartDrawer();
    });
});

document.querySelectorAll('a[href="/cart"], .button-icon-cart').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

window.addEventListener("DOMContentLoaded", () => {
  let attempts = 0;
  const maxAttempts = 5;
  const intervalTime = 1000; // 1 segundo
  
  const checkButtonExistence = setInterval(() => {
    const rigSearcherWidget = document.querySelectorAll(".easysearch-widget");
    
    if (rigSearcherWidget.length !== 0) {
      rigSearcherWidget.forEach(item => {
        const rigSearcherButton = item.querySelector("#easysearch-search")
        rigSearcherButton.addEventListener("click", () => {
        const inputs = item.querySelectorAll(".easysearch-select-holder select");
        const labelInputs = ["make", "model", "year"]
        const rigDetails = { mmy: {} };
        inputs.forEach((input, index) => {
          const label = labelInputs[index];
          const value = input.value;
          rigDetails.mmy[label] = value;
        });
        localStorage.setItem("rvRigDetails", JSON.stringify(rigDetails));
        sendRigDetails(rigDetails);
      });
      })
     

      clearInterval(checkButtonExistence); // Detener la comprobación una vez que el botón se encuentra
    } else if (attempts >= maxAttempts) {
      clearInterval(checkButtonExistence); // Detener la comprobación después del máximo de intentos
    }

    attempts++;
  }, intervalTime);

  let customerRigInfo = document.querySelectorAll(".customer-rig-info");

  let rigDetails = localStorage.getItem("rvRigDetails")
  if (!rigDetails) {
    return;
  }
  rigDetails = JSON.parse(rigDetails);
  customerRigInfo.forEach((item) => {
    item.style.display = "flex";
  });
  customerRigInfo.forEach((item) => {
    let span = document.createElement("span");
    span.className = "text-content-rig-info";
    span.innerHTML = `Your Rig: ${rigDetails.mmy.year} ${rigDetails.mmy.make} ${rigDetails.mmy.model} ${rigDetails.mmy.length ?  rigDetails.mmy.length : ""}`;
    item.appendChild(span);
  });

  
})
document.querySelectorAll('.btn-atc').forEach(item => {
  const form = item.parentElement.parentElement
  item.addEventListener('click', async() => {
    addToCart(form)
  })
})
document.querySelectorAll('.btn-atc-sticky').forEach(item => {
  const form = item.parentElement.parentElement.parentElement.parentElement.parentElement
  item.addEventListener('click', async() => {
    addToCart(form)
  })
})


document.querySelectorAll(".js-add-set").forEach((button) => {
  button.addEventListener("click", async (e) => {
    // Obtener el contenedor de los productos seleccionados
    const parentElement = button.parentElement.parentElement;
    const container = parentElement.querySelector(".container--selected-products-list");
    const productItems = container.querySelectorAll(".set-product-card__product-item"); // Obtener todos los <li> dentro del contenedor

    // Iterar sobre los productos y agregarlos uno por uno de manera secuencial
    for (const item of productItems) {
      const variantId = item.getAttribute("value"); // Obtener el valor del atributo "value" que representa el variantId

      // Crear un formulario temporal para usarlo con addToCart
      const tempForm = document.createElement("form");
      const variantInput = document.createElement("input");

      tempForm.method = "POST";
      variantInput.type = "hidden";
      variantInput.name = "id";
      variantInput.value = variantId;

      tempForm.appendChild(variantInput);

      try {
        // Usar await para esperar a que el producto se agregue antes de continuar con el siguiente
        await addToCartTemp(tempForm);
      } catch (error) {
        console.error("Error adding accessory to cart:", error);
      }
    }
  });
});

async function addToCartTemp(form) {
  // Asegurarse de que FormData reciba un HTMLFormElement
  const formData = new FormData(form);

  // Hacer el post a la ruta del carrito
  await fetch("/cart/add", {
    method: "POST",
    body: formData,
  });

  // Obtener el carrito actualizado
  const res = await fetch("/cart.js");
  const cart = await res.json();
  removeProductExtended(cart.items);
  validExcludedProduct(cart.items);
  updateCartItemCounts(cart.item_count);

  // Actualizar la vista del carrito
  await updateCartDrawer();

  // Abrir el carrito
  openCartDrawer();
}



document.addEventListener('DOMContentLoaded', () => {
  const checkboxes = document.querySelectorAll('.set-product__checkbox');

  const parsePrice = (priceText) => {
      return parseFloat(priceText.replace('$', '').replace(',', ''));
  };

  const toggleProductSelection = (checkbox) => {
      const setProductDiv = checkbox.closest(".set-product");
      const container = setProductDiv.parentElement.parentElement;
      const total_price_value = container.querySelector(".container--set-button-price");
      const priceText = setProductDiv.querySelector(".set-product__price").textContent;
      const product_list = container.querySelector(".container--selected-products-list");
      const buttonText = setProductDiv.querySelector('.set-product__button-text');
      const variantId = setProductDiv.querySelector('.set-product-card__variant-id').value;

      const price = parsePrice(priceText);
      const currentTotal = parsePrice(total_price_value.textContent);

      if (checkbox.checked) {
          setProductDiv.classList.add('selected');
          buttonText.textContent = 'Added';
          total_price_value.textContent = `$${(currentTotal + price).toFixed(2)}`;
          product_list.insertAdjacentHTML('beforeend', `<li value="${variantId}" class="set-product-card__product-item">${setProductDiv.querySelector('.set-product__title').textContent}</li>`);
      } else {
          setProductDiv.classList.remove('selected');
          buttonText.textContent = 'Add';
          total_price_value.textContent = `$${(currentTotal - price).toFixed(2)}`;
          const productItem = product_list.querySelector(`[value="${variantId}"]`);
          productItem.remove();
      }
  };

  checkboxes.forEach(checkbox => {
      const setProductDiv = checkbox.closest(".set-product");
      checkbox.checked = true;
      toggleProductSelection(checkbox);

      checkbox.addEventListener('change', () => toggleProductSelection(checkbox));

      const clickableElements = setProductDiv.querySelectorAll('.set-product__price, .set-product__image');

      clickableElements.forEach(element => {
          element.addEventListener('click', () => {
              checkbox.checked = !checkbox.checked;
              toggleProductSelection(checkbox);
          });
      });
  });
});

    
    
document.querySelectorAll(".js-add-accessory").forEach((button) => {
    button.addEventListener("click", async() => {
      const container = button.closest(".js-accessory-product");
      const variantId = container.querySelector(".accessory-card__variant-id").value;

      // Crear un formulario temporal para usarlo con addToCart
      const tempForm = document.createElement("form");
      const variantInput = document.createElement("input");

      // Configurar el formulario
      tempForm.method = "POST";
      variantInput.type = "hidden";
      variantInput.name = "id";
      variantInput.value = variantId;

      tempForm.appendChild(variantInput);

      // Llamar a addToCart con el formulario temporal
      addToCart(tempForm).catch((error) => {
        console.error("Error adding accessory to cart:", error);
      });
    });
  });